<template>
  <div class="change_phone">
    <div class="title">更换手机号码</div>
    <hr />
    <div class="content" v-loading="sendLoading">
      <el-steps
        :active="activeStep"
        finish-status="success"
        align-center
        style="margin: 20px auto 0;width: 500px;"
        v-if="activeStep !== 2"
      >
        <el-step title="验证身份"></el-step>
        <el-step title="修改手机号码"></el-step>
        <el-step title="完成更换"></el-step>
      </el-steps>
      <div class="step_content" v-if="activeStep === 0">
        <div class="content_row">
          <div class="bind_info">
            <h1>
              已绑定的手机：{{
                currentMobile.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2")
              }}
            </h1>
            <h2>若该手机号已无法使用请联系客服</h2>
          </div>
          <!-- <label>验证码：</label>
          <custom-input
            placeholder="短信验证码"
            class="content_input"
            v-model="oldMobileCaptcha"
            clearable
          >
            <a
              href="#"
              slot="suffix"
              class="sendCode"
              @click="showCaptcha(1)"
              >{{ content }}</a
            >
          </custom-input> -->
        </div>
      </div>
      <div class="step_content" v-if="activeStep === 1">
        <div class="content_row">
          <label>手机号码：</label>
          <custom-input
            placeholder="输入新的手机号码"
            class="content_input"
            v-model="newMobileForm.newMobile"
            clearable
            @blur="checkNewMobile"
          >
            <span slot="errorMessage" v-if="newMobileFormErrors.newMobile">
              {{ newMobileFormErrors.newMobile }}
            </span>
          </custom-input>
        </div>
        <div class="content_row">
          <label>验证码：</label>
          <custom-input
            placeholder="短信验证码"
            class="content_input"
            v-model="newMobileForm.newMobileCaptcha"
            clearable
            @blur="checkNewCaptcha"
          >
            <a
              href="#"
              slot="suffix"
              class="sendCode"
              @click="showCaptcha(2)"
              >{{ newSendContent }}</a
            >
            <span
              slot="errorMessage"
              v-if="newMobileFormErrors.newMobileCaptcha"
            >
              {{ newMobileFormErrors.newMobileCaptcha }}
            </span>
          </custom-input>
        </div>
      </div>
      <div class="step_content" v-if="activeStep === 2">
        <div class="success_content">
          <img
            src="@/assets/images/login/bigCorrect.png"
            alt="成功"
            class="correct_icon"
          />
          <h1>手机号码更换成功</h1>
          <h2>您可以在下次使用新号码进行登录</h2>
        </div>
      </div>
      <button class="next_btn" @click="nextStep" v-if="activeStep !== 2">
        下一步
      </button>
      <router-link
        to="/my/securitySettings"
        v-else
        style="text-decoration: none;"
      >
        <button class="next_btn">
          返回
        </button>
      </router-link>
    </div>
    <el-row>
      <el-col :span="24">
        <div class="warning">
          <h1>温馨提醒</h1>
          <p>• 为保障您的帐号安全，变更重要信息需要身份验证</p>
          <p>• 若有疑问请联系在线客服或拨打400-883-8888（24小时客服热线）</p>
        </div>
      </el-col>
    </el-row>
    <div class="loginSwitchBox" v-if="ncSwitchFlag">
      <loginSwitch @sliderCaptcha="handerSliderCaptcha"></loginSwitch>
    </div>
  </div>
</template>

<script>
import CustomInput from "@/components/business/login/CustomInput";
import my from "@/api/changeMobile";
import loginSwitch from "@/components/business/login/ncSwitch.vue";
import register from "@/api/register";
import order from "@/api/order";
import { setStorage, removeStorage, getStorage } from "@/lib/utils";
import login from "@/api/login";
import { init } from "@/lib/captchaId.js";
export default {
  name: "change-phone",
  data() {
    return {
      activeStep: 0,
      sendLoading: false,
      currentMobile: "无",
      canSend: true,
      content: "发送验证码",
      countdownTime: 60,
      newMobileCanSend: true,
      newSendContent: "发送验证码",
      newMobileSendCountdown: 60,
      oldMobileCaptcha: "",
      newMobileForm: {
        newMobile: "",
        newMobileCaptcha: "",
      },
      newMobileFormErrors: {
        newMobile: "",
        newMobileCaptcha: "",
      },
      ncSwitchFlag: false,
      isNcSwitch: false,
      slideVerifyParam: {},
      captchaFlag: true,
    };
  },
  components: {
    CustomInput,
    loginSwitch,
  },
  watch: {
    "$store.state.captchaData": function(val) {
      if (val.ticket) {
        this.captchaFlag = false;
        this.slideVerifyParam = val;
        if (this.activeStep == 0) {
          // this.sendOldMobileSms();
        }
        if (this.activeStep == 1) {
          this.sendNewMobileSms();
        }
      }
    },
  },
  methods: {
    // 打开滑块
    showCaptcha(type) {
      if (!this.captchaFlag) {
        return
      }
      if (type == 1) {
        init();
      } else {
        if (this.newMobileForm.newMobile.length === 0) {
          this.$feedback("请输入手机号码");
        } else if (
          !/^[1][3,4,5,7,8][0-9]{9}$/.test(this.newMobileForm.newMobile)
        ) {
          this.$feedback("请输入正确手机号码");
        } else {
          init();
        }
      }
    },
    nextStep() {
      if (this.activeStep === 0) {
        this.checkOldMobileSms();
      } else {
        this.updateMobile();
      }
    },
    // 退出登录
    logOut() {
      this.$feedback("手机号码更换成功，请重新登录");
      const token = getStorage("access_token");
      login.logout({ access_token: token }).then((res) => {
        if (res.status === 200) {
          removeStorage("access_token");
          removeStorage("userName");
          removeStorage("avatarUrl");
          removeStorage("userMobile");
          this.$router.push({ path: "/login" });
        } else {
          this.$feedback(res.message);
        }
      });
      removeStorage("access_token");
    },
    handleClose() {
      this.editPasswordVisible = false;
    },
    handerSliderCaptcha(data) {
      /* eslint-disable no-debugger, no-console */
      this.isNcSwitch = true;
      this.slideVerifyParam = data;
      this.sendOldMobileSms();
      this.$nextTick(() => {
        this.ncSwitchFlag = false;
      });
    },
    // 发送短信验证码
    sendOldMobileSms() {
      if (!this.canSend) return;
      // if (!this.isNcSwitch) {
      //   this.ncSwitchFlag = true;
      //   return;
      // }
      this.sendLoading = true;
      register
        .sendSmsCodeToC({
          mobile: this.currentMobile,
          slideVerifyParam: this.slideVerifyParam,
          template: "register_verification_code",
        })
        .then((res) => {
          this.sendLoading = false;
          if (res.status === 200) {
            this.$feedback.success("验证码发送成功");
            this.content = this.countdownTime + "s后重新发送";
            this.canSend = false;
            this.countdownInterval = setInterval(() => {
              this.countdownTime--;
              this.content = this.countdownTime + "s后重新发送";
              if (this.countdownTime <= 0) {
                // this.isNcSwitch = false;
                this.slideVerifyParam = {};
                clearInterval(this.countdownInterval);
                this.content = "重新发送验证码";
                this.countdownTime = 60;
                this.captchaFlag = true;
                this.canSend = true;
              }
            }, 1000);
          } else {
            // this.isNcSwitch = false;
            this.captchaFlag = true;
            this.slideVerifyParam = {};
            this.$feedback(res.message);
          }
        })
        .catch((err) => {
          // this.isNcSwitch = false;
          this.slideVerifyParam = {};
          this.$feedback(err.message);
          this.sendLoading = false;
          this.captchaFlag = true;
        });
    },
    // 验证旧手机号
    checkOldMobileSms() {
      // 已绑定手机不做任何校验
      this.captchaFlag = true;
      this.activeStep++;
      // this.sendLoading = true;
      // if (this.oldMobileCaptcha === "") {
      //   this.$feedback("验证码不能为空");
      //   this.sendLoading = false;
      //   return;
      // }
      // my.verifyMobileWithSms({
      //   oldMobile: this.currentMobile,
      //   captcha: this.oldMobileCaptcha,
      // })
      //   .then((res) => {
      //     this.sendLoading = false;
      //     if (res.status === 200) {
      //       this.captchaFlag = true;
      //       this.activeStep++;
      //     } else {
      //       this.$feedback(res.message);
      //     }
      //   })
      //   .catch((err) => {
      //     this.$feedback(err.message);
      //     this.sendLoading = false;
      //   });
    },
    // 检查新手机号
    checkNewMobile() {
      const { newMobileForm } = this;
      if (newMobileForm.newMobile === "") {
        this.newMobileFormErrors.newMobile = "手机号不能为空";
        return;
        // } else if (!(/^(1)\d{10}$/.test(newMobileForm.newMobile))) {
      } else if (!/^[1][3,4,5,7,8][0-9]{9}$/.test(newMobileForm.newMobile)) {
        this.newMobileFormErrors.newMobile = "手机号码格式不正确";
        return;
      }
      this.newMobileFormErrors.newMobile = "";
    },
    // 检查新手机号验证码
    checkNewCaptcha() {
      const { newMobileForm } = this;
      if (newMobileForm.newMobileCaptcha === "") {
        this.newMobileFormErrors.newMobileCaptcha = "验证码不能为空";
      } else {
        this.newMobileFormErrors.newMobileCaptcha = "";
      }
    },
    // 发送新手机号短信验证码
    sendNewMobileSms() {
      if (!this.newMobileCanSend) return;
      if (this.newMobileForm.newMobile.length === 0) {
        this.$feedback("请输入手机号码");
      } else if (
        !/^[1][3,4,5,7,8][0-9]{9}$/.test(this.newMobileForm.newMobile)
      ) {
        this.$feedback("请输入正确手机号码");
      } else {
        this.sendLoading = true;
        register
          .sendSmsCodeToC({
            mobile: this.newMobileForm.newMobile,
            slideVerifyParam: this.slideVerifyParam,
            template: "register_verification_code",
          })
          .then((res) => {
            this.sendLoading = false;
            if (res.status === 200) {
              this.$feedback.success("验证码发送成功");
              this.newSendContent = this.newMobileSendCountdown + "s后重新发送";
              this.newMobileCanSend = false;
              this.newCountDownInterval = setInterval(() => {
                this.newMobileSendCountdown--;
                this.newSendContent =
                  this.newMobileSendCountdown + "s后重新发送";
                if (this.newMobileSendCountdown <= 0) {
                  clearInterval(this.newCountDownInterval);
                  this.newSendContent = "重新发送验证码";
                  this.newMobileSendCountdown = 60;
                  this.newMobileCanSend = true;
                  this.captchaFlag = true;
                }
              }, 1000);
            } else {
              this.captchaFlag = true;
              this.$feedback(res.message);
            }
          })
          .catch((err) => {
            this.$feedback(err.message);
            this.sendLoading = false;
            this.captchaFlag = true;
          });
      }
    },
    // 更新手机号
    updateMobile() {
      this.checkNewMobile();
      this.checkNewCaptcha();
      const { newMobileFormErrors } = this;
      let checkFlag = true;
      Object.keys(newMobileFormErrors).forEach(function(key) {
        if (newMobileFormErrors[key] !== "") {
          checkFlag = false;
        }
      });
      if (!checkFlag) {
        return;
      }
      this.sendLoading = true;
      my.changeMobile({
        newMobile: this.newMobileForm.newMobile,
        captcha: this.newMobileForm.newMobileCaptcha,
      })
        .then((res) => {
          this.sendLoading = false;
          if (res.status === 200) {
            // this.updateUserInfo()
            this.activeStep++;
            this.logOut();
          } else {
            this.$feedback(res.message);
          }
        })
        .catch((err) => {
          this.$feedback(err.message);
          this.sendLoading = false;
        });
    },
    // 更新常用数据
    updateUserInfo() {
      order
        .getUserInfo()
        .then((res) => {
          if (res.status === 200) {
            const account = res.data;
            setStorage("userMobile", account.mobile);
            setStorage("userName", account.displayName);
            setStorage("avatarUrl", account.avatarUrl);
          } else {
            this.$feedback(res.message);
          }
        })
        .catch((err) => {
          this.$feedback(err.message);
        });
    },
  },
  created() {
    order.getUserInfo().then((res) => {
      if (res.status === 200) {
        const account = res.data;
        if (account.mobile) {
          this.currentMobile = account.mobile;
        }
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.loginSwitchBox {
  position: absolute;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #00000030;
  display: flex;
  align-items: center;
  justify-content: center;
}
.change_phone {
  width: 1085px;
  background: white;
  float: right;
  margin-bottom: 50px;
  box-shadow: 0px 1px 0px 0px rgba(224, 224, 224, 1);
  padding: 40px;
  box-sizing: border-box;
  .title {
    font-size: 24px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 33px;
  }
  hr {
    height: 2px;
    background: rgba(224, 224, 224, 1);
    margin: 40px 0;
    border: none;
  }
  .content {
    ::deep {
      .el-step__icon.is-text {
        height: 57px;
        width: 57px;
        background: #ccc;
        color: #fff;
        font-size: 35px;
        font-weight: 700;
        border: none;
      }
      .el-step__head.is-process .el-step__icon {
        background: #000;
      }
      .el-step__title.is-process {
        color: #252525;
      }
      .el-step__head.is-success {
        .el-step__icon {
          background: #000;
        }
        .el-step__line {
          background: #000;
        }
      }
      .el-step__title.is-wait {
        color: #999;
      }
      .el-step__line {
        top: 28px;
        background: #ccc;
      }
      .el-step__title.is-success {
        color: #000;
      }
    }
    .sendCode {
      width: 90px;
      height: 25px;
      font-size: 18px;
      font-weight: 400;
      color: #da1e46;
      line-height: 48px;
      text-decoration: none;
    }
    .step_content {
      margin-top: 100px;
      .bind_info {
        text-align: center;
        margin-bottom: 60px;
        h1 {
          font-size: 22px;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 30px;
          letter-spacing: 2px;
        }
        h2 {
          font-size: 18px;
          font-weight: 400;
          color: rgba(119, 119, 119, 1);
          line-height: 25px;
          margin-top: 10px;
        }
      }
      .content_row {
        padding: 0 200px;
        .content_input {
          width: 500px;
          height: 56px;
          margin: 0 auto 40px;
          display: inline-block;
        }
        label {
          width: 100px;
          text-align: right;
          font-size: 20px;
          line-height: 48px;
          display: block;
          float: left;
        }
      }
    }
    .next_btn {
      width: 200px;
      height: 56px;
      background: #000;
      color: white;
      font-size: 22px;
      font-weight: 500;
      line-height: 30px;
      letter-spacing: 1px;
      outline: none;
      border: none;
      cursor: pointer;
      display: block;
      margin: 0px auto;
      &:disabled {
        background: #dcdcdc;
        cursor: not-allowed;
      }
    }
  }
  .warning {
    background: rgba(249, 249, 249, 1);
    opacity: 0.757;
    margin-top: 100px;
    padding: 15px;
    h1 {
      font-size: 18px;
      font-weight: bold;
      color: rgba(153, 153, 153, 1);
      line-height: 25px;
      margin-bottom: 20px;
    }
    p {
      font-size: 18px;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      line-height: 25px;
    }
  }
  .success_content {
    text-align: center;
    h1 {
      font-size: 24px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 33px;
      margin-top: 20px;
    }
    h2 {
      font-size: 18px;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      line-height: 25px;
      margin-top: 10px;
      margin-bottom: 40px;
    }
  }
}
</style>
